<div>
    <span class="text-xl"> {{ title() | transloco }}</span>
    <span class="text-base pl-2">({{ count() }})</span>
</div>
